export const CONTROLS_VISIBILITY_MODE_TYPE = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
  HOVER: 'hover',
}

export const repeatIconName = 'repeat'
export const playIconName = 'play_rounded'
export const pauseIconName = 'pause_rounded'
